import React from "react";
import {
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Fab,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import YesNoQuestion from "./YesNoQuestion";
import RangeQuestion from "./RangeQuestion";
import ChoiceQuestion from "./ChoiceQuestion";
import TextQuestion from "./TextQuestion";

const QuestionFilters = ({ questions, update }) => {


  const handleQuestionFilterUpdate = (action, questionId, answer) => {
    update(action, questionId, answer);
  };

  const renderQuestions = (category) => {
    const qList = questions.filter((q) => q.category === category);
    return qList[0].questions.map((question) => {
      if (question.questionType === "yesno") {
        return (
          <YesNoQuestion
            key={question._id}
            questionData={question}
            update={handleQuestionFilterUpdate}
          />
        );
      } else if (question.questionType === "choice") {
        return (
          <ChoiceQuestion
            key={question._id}
            questionData={question}
            update={handleQuestionFilterUpdate}
          />
        );
      } else if (question.questionType === "range") {
        return <RangeQuestion key={question._id} questionData={question} />;
      } else if (question.questionType === "text") {
        return <TextQuestion key={question._id} questionData={question} />;
      }
    });
  };

  return (
    <Grid container>
      {questions ? (
        <Grid item xs={12}>
          {questions.map((data) => {
            return (
              <Accordion key={data?.category}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="button">{data?.category}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container direction="column" spacing={3}>
                    {renderQuestions(data?.category)}
                  </Grid>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </Grid>
      ) : (
        <></>
      )}
    </Grid>
  );
};

export default QuestionFilters;
